@if (isDataAvailable) {
<div id="chart">
  <h2 class="chart-title">
    {{ chartOptions.title.text }}
  </h2>
  <div class="chart-overlay">
    <apx-chart
      #chart
      [series]="chartOptions.series"
      [chart]="chartOptions.chart"
      [labels]="chartOptions.labels"
      [dataLabels]="chartOptions.dataLabels"
      [colors]="chartOptions.colors"
      [responsive]="chartOptions.responsive"
      [legend]="chartOptions.legend"
      [tooltip]="chartOptions.tooltip"
      [plotOptions]="chartOptions.options.plotOptions"
    ></apx-chart>

    <svg
      class="gauge"
      viewBox="0 0 200 200"
      preserveAspectRatio="xMidYMid meet"
    >
      <g transform="translate(100, 100)">
        <g *ngFor="let tick of ticks; let i = index">
          <line
            [attr.x1]="getX(i, radius)"
            [attr.y1]="getY(i, radius)"
            [attr.x2]="getX(i, radius - 5)"
            [attr.y2]="getY(i, radius - 5)"
            stroke="#b9b9b9"
            stroke-width="1"
          />
          <text
            *ngIf="i % 25 === 0"
            [attr.x]="getX(i, radius + 5)"
            [attr.y]="getY(i, radius + 5)"
            text-anchor="middle"
            font-size="6"
          >
            {{ i }}
          </text>
        </g>
      </g>
    </svg>

    <div class="donut-center">
      <div class="donut-value" *ngIf="hoveredItem!= null">
        <span class="value">
          {{ hoveredItem.amount | number:'1.0-0' }}%
        </span>
        <span class="label">
          {{ hoveredItem.label }}
        </span>
      </div>
    </div>
  </div>
  <div class="chart-legend">
    <div
      class="legend-item"
      *ngFor="let item of data.items"
      [style.color]="item.color"
    >
      <span class="legend-value">{{ item.value }}</span>
      <span class="legend-label">{{ item.label }}</span>
    </div>
  </div>
</div>
} @else {
<div class="message">
  <p>No hay datos para mostrar :(</p>
</div>
}
